import React, { useEffect, useState } from "react";
import StepperPage from "./stepper";
import { applicantLookups } from "../../../API/services/utilities";
import { resolver } from "../../../API/middlewares/resolveRequests";
import HOC from "../../../API/middlewares/HOC";
import errorCode from "../../../algorithms/errorLibrary";
import Loading from "../../reusableComponents/loadingScreens";
import ErrorScreen from "../../reusableComponents/errorScreen";
import { Link } from "react-router-dom";
const Register = () => {
  const [dropdownLists, setDropdownLists] = useState(null);
  const [tryAgain, setTryAgain] = useState(false);
  useEffect(() => {
    resolver(applicantLookups, setDropdownLists);
  }, [tryAgain]);
  return HOC(
    sss,
    Loading,
    1,
    ErrorScreen,
    dropdownLists,
    errorCode,
    staticReander,
    // { tryAgain, setTryAgain }
    undefined
  );
};

export default Register;

const sss = (dropdownLists) => {
  return (
    <>
      <StepperPage dropdownLists={dropdownLists.data} />
    </>
  );
};

const staticReander = (comp, Lang, ...params) => {
  return (
    <>
      <div className="container">
        <div className="justify-content-center d-flex py-3">
          <img src="/assets/images/loginlogo.jpg" className="rounded-circle" />
        </div>
        <h4 className="text-center">{Lang.registerMessage} </h4>
        <h6 className="text-center">
          <Link to="/">{Lang.hasAcc}</Link>
        </h6>
        {/* <div className="d-flex justify-content-center my-3">
          <DropDownList
            change={(e) => {
              setStorageValue("language", e.value);
            }}
            border={true}
            dataSource={["en", "ar"]}
            placeholder={"language"}
          ></DropDownList>{" "}
        </div> */}
        {comp()}
      </div>
    </>
  );
};
